import { useEffect } from 'react';
import { Input } from '@treezor/design-system';
import { useFormContext } from 'react-hook-form';

import { useMailInput } from '@/features/user/hooks/createUser/useMailInput';

interface ICompanyMemberEmail {
  memberKey: string;
  isEmailNotAlreadyUsed: (field: string) => boolean;
}

export const CompanyMemberEmail = ({ memberKey, isEmailNotAlreadyUsed }: ICompanyMemberEmail) => {
  const { setError, watch, register, clearErrors } = useFormContext();

  const {
    iconStatus,
    error: emailError,
    handleAsyncBlur: handleEmailBlur,
  } = useMailInput({ key: memberKey, initialValue: watch(memberKey), isFieldValid: isEmailNotAlreadyUsed });

  useEffect(() => {
    !!emailError ? setError(memberKey, { message: emailError }) : clearErrors(memberKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emailError]);

  return (
    <Input
      type="text"
      icon={{ left: 'mail', right: iconStatus }}
      label=""
      error={emailError}
      {...register(memberKey)}
      onBlur={handleEmailBlur}
    />
  );
};
